export default __webpack_public_path__ + "static/media/GuidelinesAR.7dd7c2f2.pdf";